const styles = () => ({
  appBar: {
    backgroundColor: '#fff',
  },
  toolbar: {
    minHeight: 60,
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.20)',
  },
  logo: {
    minWidth: 178,
  },
  menuItem: {
    width: 100,
    fontSize: '.9375rem',
  },
  gridItem: {
    paddingLeft: 0,
    paddingRight: 0,
  },
})

export default styles



// WEBPACK FOOTER //
// ./src/sections/header/styles.js